import UploadAdapter, { progressEventType } from '../UploadAdapter';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import api from '@/service/api';
import uploadRequest from '../requestQueue';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: 'AIzaSyBwJ5gtS-PrBxbxZq3Pli82t_8hKel_JA0',
    authDomain: 'raws-c88ca.firebaseapp.com',
    databaseURL: 'https://raws-c88ca.firebaseio.com',
    projectId: 'raws-c88ca',
    storageBucket: 'raws-c88ca.appspot.com',
    messagingSenderId: '503956124688',
    appId: '1:503956124688:web:ea33d22d6a8a95a9',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

let credential: firebase.auth.UserCredential;

const firebaseUploadService: UploadAdapter = {
    name: 'firebase',
    async uploadFile(ticket, image, progressCallback) {
        const controller = new AbortController();
        let task: firebase.storage.UploadTask | undefined;
        const cancel = () => { controller.abort(); task?.cancel(); };
        const requests: Promise<string>[] = [];
        const types = ['small-thumb', 'large-thumb', 'no-watermark'] as const;
        const blobs = [image.file, image.thumbnails.smallThumb, image.thumbnails.largeThumb, image.thumbnails.noWatermark];
        const uploaded = blobs.map(() => 0);
        const overall = blobs.reduce((sum, blob) => sum + blob.size, 0);
        const progress = (event: progressEventType) => {
            if (!controller.signal.aborted) progressCallback(uploaded.reduce((sum, bytes) => sum + bytes, 0), overall, event);
        };
        image.signal.addEventListener('abort', cancel, { once: true });
        try {
            if (image.signal.aborted) return { cancelled: true };
            if (!credential) credential = await firebase.auth().signInWithCustomToken(ticket.data);
            if (controller.signal.aborted) return { cancelled: true };
            progress('begin');
            const ref = firebase.storage().ref().child(`/sessions/123/${ticket.sessionId}/${image.id}`);
            task = ref.put(image.file, { cacheControl: 'max-age=31536000', contentType: '' });
            task.on('state_changed', snapshot => {
                uploaded[0] = snapshot.bytesTransferred;
                progress('progress');
            });
            await task;
            for (const [index, type] of types.entries()) {
                requests.push(uploadRequest(() => api.uploadFile(ticket.sessionId, image.id, type, blobs[index + 1],
                    (loaded, total) => {
                        uploaded[index + 1] = Math.min(blobs[index + 1].size,
                            total > 0 ? loaded / total * blobs[index + 1].size : loaded);
                        progress('progress');
                    }, controller.signal,
                ), controller.signal));
            }
            const [smallThumbUrl, largeThumbUrl] = await Promise.all(requests);
            if (controller.signal.aborted) return { cancelled: true };
            blobs.forEach((blob, index) => uploaded[index] = blob.size);
            progress('finish');
            return { cancelled: false, smallThumbUrl, largeThumbUrl };
        } catch (error) {
            controller.abort();
            await Promise.allSettled(requests);
            if (!image.overwrite && task) {
                await Promise.allSettled([task.snapshot.ref.delete(), ...types.map(type =>
                    api.deleteFile(ticket.sessionId, image.id, type))]);
            }
            if (image.signal.aborted) return { cancelled: true };
            throw error;
        } finally {
            image.signal.removeEventListener('abort', cancel);
        }
    },
};

export default firebaseUploadService;
